"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldDataToKeepThisEditStep = exports.FieldEditStep = void 0;
const __1 = require("../../..");
const FieldEditStep = (props, setThisStep, index) => {
    setThisStep((prev) => {
        let cloneStep = (0, __1.FunctionCloneDeep)([...prev]);
        cloneStep[index] = props.fields;
        return cloneStep;
    });
};
exports.FieldEditStep = FieldEditStep;
const FieldDataToKeepThisEditStep = (props, index, setKeepData, setEditIndex, data) => {
    if (props.grandParentKey === props.parentKey) {
        if (props.FieldReference.current[props.parentIndex][props.parentKey]) {
            let cloneData = (0, __1.FunctionCloneDeep)(props.FieldReference.current[props.parentIndex][props.parentKey]);
            cloneData[index] = data;
            setKeepData({ [props.parentKey]: cloneData });
            setEditIndex(null);
        }
    }
    else {
        if (props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentIndex][props.parentKey]) {
            let cloneData = (0, __1.FunctionCloneDeep)(props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentIndex][props.parentKey]);
            cloneData[index] = data;
            const newData = Object.assign(Object.assign({}, props.FieldReference.current[props.grandParentIndex]), { [props.grandParentKey]: Object.assign(Object.assign({}, props.FieldReference.current[props.grandParentIndex][props.grandParentKey]), { [props.parentIndex]: Object.assign(Object.assign({}, props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentIndex]), { [props.parentKey]: cloneData }) }) });
            setKeepData(newData);
            setEditIndex(null);
        }
    }
};
exports.FieldDataToKeepThisEditStep = FieldDataToKeepThisEditStep;
